export default __webpack_public_path__ + "static/media/hub_label_box_label.8fbac610.webp";